<template>
<div>
  <!-- Abstract Preview -->
  <el-dialog :title="pubToShow.code" :visible.sync="pubToShow.visible">
    <div align="center" style="height: 500px; overflow-x: auto">
      <div><h3>{{pubToShow.title}}</h3></div>
      <div>{{pubToShow.authors.join(",")}}</div>
      <br>
      <div align="justify">{{pubToShow.abstract}}</div>
    </div>
  </el-dialog>

  <!-- Logo -->
  <div style="padding: 5px; width: 800px; height: 41px">
    <div style="margin-right: 5px; height: 30px" align="right">
      <img src="../assets/publications.gif" style="width:300px; height:30px" />
    </div>
  </div>

  <!-- Search -->
  <div>
    <div style="display:flex;align-items:center;float:right">
      <div v-if="searchKey!==''" style="margin-right:30px;color:#bbbbbb;height:100%">
        {{pubsToShow.length}} Results
      </div>

      <div class="greybox">
        Look for <input @keyup.enter="updateSearch()" style="width:80px" type="text" v-model="searchKey" /> in
        <nd-select v-model="searchFilter">
          <nd-option>All</nd-option>
          <nd-option>Authors</nd-option>
          <nd-option>Journal</nd-option>
          <nd-option>Topic</nd-option>
          <nd-option>Year</nd-option>
        </nd-select>
        <el-button @click="updateSearch()" type="info" size="mini" plain>Search</el-button>
        <el-button @click="searchKey='';updateSearch()" type="info" size="mini" plain>Clear</el-button>
      </div>
    </div>

    <div style="clear:both"></div>
  </div>

  <div style="display: flex;width:100%">
    <!-- Navigation -->
    <div class="greybox" style="width:300px">
      <h3>Filters</h3>

      <div style="margin-bottom:25px" v-for="(filter,ind) in defaultFilters" :key="ind">
        <div style="margin-bottom:10px">
          <div style="float:left;"><b>{{filter}}</b></div>

          <div style="float:right">
            <pub-nav-select text="Num" v-model="filterConfigs[filter].numClusters">
              <pub-nav-option>4</pub-nav-option>
              <pub-nav-option>20</pub-nav-option>
              <pub-nav-option>50</pub-nav-option>
              <pub-nav-option>All</pub-nav-option>
            </pub-nav-select>
          </div>

          <div style="float:right">
            <pub-nav-select text="Sort" v-model="filterConfigs[filter].sortKey">
              <pub-nav-option v-for="(k,ind) in filterConfigs[filter].sortKeys" :key="ind">{{k}}</pub-nav-option>
            </pub-nav-select>
          </div>

          <div style="clear:both"></div>
        </div>


        <div style="margin-left:10px">
          <ul>
            <li v-for="(c,ic) in (filterConfigs[filter].numClusters === 'All' ? defaultClusters[filter] : defaultClusters[filter].slice(0, filterConfigs[filter].numClusters))" :key="ic">
              <a style="cursor:pointer;color:black" @click="searchFilter=filter;searchKey=c.key;updateAccurateSearch()">{{c.key}}</a> ({{c.values.length}})
            </li>
            <li>
            <a @click="filterConfigs[filter].numClusters = (filterConfigs[filter].numClusters === 'All' ? 4 : 'All')" style="cursor:pointer">{{filterConfigs[filter].numClusters === 'All' ? 'Hide' : 'Show All'}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Publications -->
    <div class="greybox" style="width:100%">
      <ul>
        <li v-for="(publication,ipub) in pubsToShow" :key="ipub">
          <div style="margin-bottom:10px">
            {{publication.originalAuthors}} "{{publication.title}}", <i>{{publication.journal}}</i>, {{getPubVolumePage(publication)}}, ({{publication.year}}) {{publication.note}}<br>
            <template v-if="publication.abstract">[<a style="cursor:pointer" @click="showAbstract(publication)">Abstract</a>]</template>
            <template v-if="publication.has_pdf==='yes'">[<a target="_blank" :href="$store.state.host+'/dokhlab/actions/download?name=papers/pdf/'+publication.code+'.pdf'">PDF</a>]</template>
            <template v-if="publication.suppinfo==='yes'">[<a target="_blank" :href="$store.state.host+'/dokhlab/actions/download?name=papers/suppl/'+publication.code+'-SuppInfo.pdf'">Supporting Information</a>]</template>
            <template v-if="publication.news">[<a :href="publication.news" target="_blank">News</a>]</template>
            <template v-if="publication.f1000&&publication.f1000!=='no'">[<a :href="publication.f1000" target="_blank">F1000</a>]</template>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Publications',

  data () {
    return {
      publications: [],

      pubToShow: {
        code: '',
        authors: ['', ''],
        title: '',
        visible: false,
        abstract: ''
      },

      searchKey: '',

      searchFilter: 'All',

      pubsToShow: [],

      filterConfigs: {
        Authors: {
          numClusters: 4,
          sortKeys: ['Name', 'Number'],
          sortKey: 'Number'
        },
        Journal: {
          numClusters: 4,
          sortKeys: ['Name', 'Importance', 'Number'],
          sortKey: 'Importance'
        },
        Topic: {
          numClusters: 4,
          sortKeys: ['Name', 'Number'],
          sortKey: 'Number'
        },
        Year: {
          numClusters: 4,
          sortKeys: ['Year', 'Number'],
          sortKey: 'Year'
        }
      }
    }
  },

  computed: {
    defaultFilters () {
      return Object.keys(this.filterConfigs)
    },

    defaultClusters () {
      let v = this
      var clusters = {}
      this.defaultFilters.forEach(filter => {
        let k = v.filterConfigs[filter].sortKey
        if (k === 'Number') {
          clusters[filter] = this.cluster(this.accurateSearch(this.publications, '', filter), filter).sort((a, b) => b.values.length - a.values.length)
        } else if (k === 'Year' && filter === 'Year') {
          clusters[filter] = this.cluster(this.accurateSearch(this.publications, '', filter), filter).sort((a, b) => b.key - a.key)
        } else if (k === 'Importance' && filter === 'Journal') {
          clusters[filter] = this.cluster(this.accurateSearch(this.publications, '', filter), filter).sort((a, b) => v.journalImportance(b.key) - v.journalImportance(a.key))
        } else if (k === 'Name') {
          clusters[filter] = this.cluster(this.accurateSearch(this.publications, '', filter), filter).sort((a, b) => a.key.localeCompare(b.key))
        } else {
          clusters[filter] = this.cluster(this.accurateSearch(this.publications, '', filter), filter).sort((a, b) => b.values.length - a.values.length)
        }
      })
      return clusters
    }
  },

  methods: {
    journalImportance (journal) {
      let journals = [
        'Chemical Reviews',
        'Journal of the American Chemical Society', 'JACS',
        'Physical Review Letters', 'PRL',
        'Proceedings of the National Academy of Sciences USA', 'PNAS',
        'Neuron',
        'Nucleic Acids Research', 'NAR',
        'Scientific Reports',
        'Structure',
        'Bioinformatics',
        'Plos Comp. Biol.', 'Plos Computational Biology',
        'RNA',
        'Biophysical Journal',
        'Journal of Molecular Biology',
        'Proteins: Structure, Function, and Bioinformatics', 'Proteins',
        'Proteins: Structure, Function, and Genetics',
        'Journal of Biological Chemistry',
        'Journal of Chemical Information and Modeling', 'JCIM',
        'Public Library of Science ONE', 'PLOS ONE',
        'Physica A',
        'Physical Review E',
        'Physics Letters B'
      ].map(s => s.toUpperCase())
      let str = journal.toUpperCase()
      let ind = journals.findIndex(s => s === str)
      if (ind === -1) {
        if (str === 'SCIENCE') {
          return 100
        } else if (str === 'CELL') {
          return 99
        } else if (str === 'NATURE') {
          return 98
        } else if (str.startsWith('SCIENCE ')) {
          return 97
        } else if (str.startsWith('NATURE ')) {
          return 96
        } else {
          return 0
        }
      } else {
        return 50 - ind
      }
    },

    showAbstract (publication) {
      var v = this
      v.pubToShow.authors = publication.authors
      v.pubToShow.title = publication.title
      v.pubToShow.abstract = publication.abstract
      v.pubToShow.visible = true
    },

    updateSearch () {
      var ls = this.search(this.publications, this.searchKey, this.searchFilter)
      ls.sort((a, b) => b.pub_id - a.pub_id)
      this.pubsToShow = ls
    },

    updateAccurateSearch () {
      var ls = this.accurateSearch(this.publications, this.searchKey, this.searchFilter)
      ls.sort((a, b) => b.pub_id - a.pub_id)
      this.pubsToShow = ls
    },

    search (pubs, key, filter) {
      if (key === '') {
        return pubs
      } else if (filter === '' || filter.toUpperCase() === 'ALL') {
        return pubs.filter(pub => this.getPubContent(pub).toUpperCase().includes(key.toUpperCase()))
      } else if (filter.toUpperCase() === 'AUTHORS') {
        return pubs.filter(pub => this.getProp(pub, 'authors').filter(author => author.toUpperCase().includes(key.toUpperCase())).length > 0)
      } else {
        return pubs.filter(pub => this.getProp(pub, filter).toUpperCase().includes(key.toUpperCase()))
      }
    },

    accurateSearch (pubs, key, filter) {
      if (key === '') {
        return pubs
      } else if (filter.toUpperCase() === 'AUTHORS') {
        return pubs.filter(pub => this.getProp(pub, 'authors').filter(author => author.toUpperCase() === key.toUpperCase()).length > 0)
      } else {
        return pubs.filter(pub => `${this.getProp(pub, filter)}`.toUpperCase() === `${key}`.toUpperCase())
      }
    },

    filterKeys (pubs, filter) {
      var keys = []
      pubs.forEach((pub, ind) => {
        let prop = this.getProp(pub, filter)
        let props = this.splitProp(prop, filter)
        props.forEach((p, i) => {
          if (!keys.includes(p)) {
            keys.push(p)
          }
        })
      })
      return keys.filter(key => key != null && key !== '')
    },

    cluster (pubs, filter) {
      return this.filterKeys(pubs, filter).map(key => { return {key: key, values: this.accurateSearch(pubs, key, filter)} })
    },

    splitProp (prop, filter) {
      if (filter.toUpperCase() === 'AUTHORS') {
//          var found = prop.match(/^(?:\s*((?:[A-Za-z-]+),\s*[A-Za-z-]+\.\s*(?:\s*[^.\s]+\.\s*)*),?\s*)+(?:\s*and\s+([A-Za-z-]+\s*,\s*[^.\s]+\.\s*(?:\s*[^.\s]+\.\s*)*),?\s*)?$/)
        return prop
      } else {
        return [prop]
      }
    },

    getPubContent (publication) {
      return `${publication.originalAuthors} "${publication.title}" ${publication.journal} ${publication.volume}:${publication.fpage}-${publication.lpage} (${publication.year})`
    },

    getPubVolumePage (publication) {
      return publication.fpage.trim() ? ((publication.volume.trim() ? `${publication.volume}:` : '') + publication.fpage + (publication.lpage.trim() ? `-${publication.lpage}` : '')) : `in press`
    },

    getProp (obj, key) {
      for (var k in obj) {
        if (k.toUpperCase() === key.toUpperCase()) {
          return obj[k]
        }
      }
      return ''
    },

    formatAuthors () {
      this.publications.forEach(pub => {
        let authors = []
        let firstName = ''
        let lastName = ''
        pub.authors.split(/and |[, ]/).forEach((name, ind) => {
          name = name.replace(/\s+/g, '')
          if (name !== '') {
            if (name[name.length - 1] === '.') {
              firstName += name
            } else {
              if (ind !== 0) {
                authors.push(`${lastName}, ${firstName}`)
                firstName = ''
                lastName = ''
              }
              lastName = name
            }
          }
        })
        authors.push(`${lastName}, ${firstName}`)
        pub.originalAuthors = pub.authors
        pub.authors = authors
      })
    },

    getPubs () {
      axios({
        method: 'get',
        url: this.$store.state.host + '/dokhlab/actions/publications'
      }).then(response => {
        this.publications = response.data
        this.publications.sort((a, b) => b.pub_id - a.pub_id)
        this.formatAuthors()
        this.pubsToShow = this.publications
      }).catch(() => {
        alert('Fetch publications failed!')
      })
    }
  },

  async mounted () {
    await this.getPubs()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.introduction {
  padding: 10px 30px;
  color: #5a5e66;
  font-size: 14px;
  text-align: justify;
}

img {
  width: 50%;
}

</style>
